import React, { useState } from 'react';
import { OutsideClickHandler, ResponsiveImage } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import css from './BookmarkContainer.module.css';
import { fetchBookMarList, fetchSpecificPost } from '../../CircleCommunityPage.duck';
import { useDispatch } from 'react-redux';
import { createResourceLocatorString } from '../../../../util/routes';
import { FormattedMessage } from '../../../../util/reactIntl';
import { abbreviateName } from '../../../../util/circleHelper';

const BookmarkContainer = props => {
  const {
    bookmarkRecord,
    onDeleteBookMark,
    bookmarkId,
    setIsBookmarkListRequested,
    history,
    routeConfiguration,
    spaceListData = {},
  } = props;

  const { author, id, name, body, space, attachment_count } = bookmarkRecord || {};
  const { name: authorName, avatar_url } = author || {};
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleUnsave = () => {
    setIsOpen(false);
    onDeleteBookMark({ bookmarkId: bookmarkId, postId: id, spaceId: space?.id })
    .then(res=>{
       dispatch(fetchBookMarList({}));
    })
  };

  const handleItemClick = () => {
    const { id: spaceId, slug } = space;
    const apiParams = {
      spaceId: spaceId,
      postId: id,
    };

    setIsBookmarkListRequested(false);
    dispatch(fetchSpecificPost(apiParams));

    return history.push(
      createResourceLocatorString(
        'PostViewPage',
        routeConfiguration,
        { spaceId, slug, postId: id },
      )
    );
  };

  return (
    <div className={css.bookmarkModalContainer}>
      <div className={css.createPostWrapper} onClick={handleItemClick}>
        <div className={css.imageleft}>
          {avatar_url ?
            <ResponsiveImage imagewithURL={avatar_url} /> :
            <div className={css.nameWrapper}>{abbreviateName(name)}</div>
          }
        </div>
        <div className={css.rightDescription}>
          <div className={css.postTitle}>{name ? name : 'Untitled Post'}</div>
          <div className={css.postDescription}>{body?.split('\n').length ? body?.split('\n').map((e) => {
            return (
              <span>{e}<br /></span>
            )
          }) : body}</div>
          <div className={css.attachmentCount}>
            {attachment_count > 0 ? attachment_count : null}
          </div>
          <div className={css.authorName}>{authorName}</div>
        </div>
      </div>
      <div className={css.dropdownDots}>
        <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
          <span onClick={toggleDropdown} className={css.iconWrapper}>
            <ProfileIconCard type="dot" />
          </span>
          {isOpen ? (
            <div className={css.dropdownMenu}>
              <ul>
                <li onClick={() => handleUnsave()}>
                  <FormattedMessage id="CircleFeedPage.unsave" />
                </li>
              </ul>
            </div>
          ) : null}
        </OutsideClickHandler>
      </div>
    </div>
  );
};
export default BookmarkContainer;
